import React, { Fragment } from 'react'

import { Accordion, AccordionItem, Flex, H5, P } from 'ui/bend'
import { SubscribeProvider } from 'context'

import RenewStripeForm from './RenewStripeForm'
import PaymentMethods from './PaymentMethods'
import CancelMembership from './CancelMembership'
import { useActiveMembershipContext } from '../../ActiveMembershipStore'
import createDOMPurify from 'dompurify'

const RenewStripe = () => {
  const { plan, paymentMethodsError, membershipInfo } =
    useActiveMembershipContext()
  const { sanitize } = createDOMPurify(window)
  const { isFlexUser } = membershipInfo

  return (
    <Fragment>
      {plan && (
        <Flex flexDirection='column'>
          <H5 color='primary'>Your payment schedule</H5>
          {plan.description && (
            <P
              dangerouslySetInnerHTML={{ __html: sanitize(plan.description) }}
            ></P>
          )}

          <SubscribeProvider
            forms={['membership']}
            forUpdate
            selectedPlanId={null}
          >
            <Accordion>
              {!isFlexUser && (
                <AccordionItem
                  title='Change membership'
                  id='settings-change-membership'
                  aria-controls='settings-membership-form'
                >
                  <RenewStripeForm cta='Update Membership' />
                </AccordionItem>
              )}

              {/* 
                Users should still be able to change their payment method if paymentMethodsError === 500.
              */}
              {paymentMethodsError !== 404 && !isFlexUser && (
                <AccordionItem
                  title='Change payment method'
                  id='settings-change-payment-method'
                  aria-controls='settings-change-payment-form'
                >
                  <PaymentMethods />
                </AccordionItem>
              )}

              <AccordionItem
                title='Cancel membership'
                id='settings-cancel-membership'
                aria-controls='settings-cancellation-form'
              >
                <CancelMembership />
              </AccordionItem>
            </Accordion>
          </SubscribeProvider>
        </Flex>
      )}
    </Fragment>
  )
}

export default RenewStripe
